{
  "recaptcha_site_key": "6LeUpqwcAAAAAIbPGZBewpl-dRr-Ca7x86v_8Mc0",
  "firebase_api_key": "AIzaSyCiap1CNmRfZ2eNXKMmjEmoYLCc197cUiI",
  "release": "b317962e7efb00016ff4c21feebd2e1c6f8a5f66"
}
